import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

interface State {
  scrollData: Record<string, number>;
  isAiChatOpen: boolean;
}

interface UpdateScrollDataProps {
  key: string;
  scrollValue: number;
}
interface ResetStatesWithIdProps {
  ids: string[];
}

const initialState: State = {
  scrollData: {},
  isAiChatOpen: false,
};

export const contextualMenuSlice = createSlice({
  name: 'contextualMenu',
  initialState,
  reducers: {
    updateScrollData: (state, action: PayloadAction<UpdateScrollDataProps>) => {
      state.scrollData[action.payload.key] = action.payload.scrollValue;
    },
    resetStatesWithId: (state, action: PayloadAction<ResetStatesWithIdProps>) => {
      action.payload.ids.forEach((id) => {
        state.scrollData[id] = 0;
      });
    },
    setAiChatOpen: (state, action: PayloadAction<boolean>) => {
      state.isAiChatOpen = action.payload;
    },
  },
});

export const {updateScrollData, resetStatesWithId, setAiChatOpen} = contextualMenuSlice.actions; // Exported setAiChatOpen
export const contextualMenuReducer = contextualMenuSlice.reducer;
